export const QUERY_KEY = Object.freeze({
  users: 'users',
  usersDropdown: 'users-dropdown',
  userCheck: 'user-check',
  user: 'user',

  companies: 'companies',
  companiesDropdown: 'companies-dropdown',
  companiesData: 'companies-data',
  company: 'company',

  sectors: 'sectors',
  sector: 'sector',
  sectorsDropdown: 'sectors-dropdown',
  sectorStructure: 'sector-structure',

  employees: 'employees',
  employee: 'employee',
  employeeCalculation: 'employee-calculate',
  additionalHolidayDays: 'additional-holiday-days',
  employeesDropdown: 'employee-dropdown',

  salaries: 'salaries',
  employeeSalary: 'employee-salary',

  requests: 'requests',
  request: 'request',

  documents: 'documents',
  employeeHrDocuments: 'employee-hr-documents',
  allDocuments: 'all-documents',
  document: 'document',

  currencies: 'currencies',
  calculatorCurrencies: 'calculator-currencies',

  guidelines: 'guidelines',
  guidelinesCategories: 'guidelines-categories',

  invoices: 'invoices',
  invoice: 'invoice',
  invoiceProjects: 'invoice-projects',
  sefVatCatalog: 'sef-vat-catalog',
  invoicePrepayments: 'invoice-prepayments',
  invoiceCorrectables: 'invoice-correctables',
  invoiceExchangeRate: 'invoice-exchange-rate',

  customers: 'customers',
  customer: 'customer',
  customerSearch: 'customer-search',

  products: 'products',
  product: 'product',

  measures: 'measures',

  enums: 'enums',

  supports: 'supports',
  support: 'support',
  supportsUnreadCount: 'supports-unread-count',

  history: 'history',

  customTemplateTokens: 'custom-template-tokens',

  timesheetReview: 'timesheet-review',
  timesheetOverview: 'timesheet-overview',
  salaryDayDetails: 'salary-day-details',
});
